import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f98098a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-2",
  class: "page-2"
}
const _hoisted_2 = { class: "box box-1" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h3 class=\"title\" data-v-5f98098a> 온라인 참여 일정 </h3><div class=\"d-block d-md-none\" data-v-5f98098a><p data-v-5f98098a><strong data-v-5f98098a>6월 5일 ‘환경의날’</strong>을 <br data-v-5f98098a>시작으로 하는 종이팩 수거 캠페인</p><p data-v-5f98098a>종이 박스에 깨끗하게 말린 일반팩 / 멸균팩을 <br data-v-5f98098a>차곡 차곡 쌓고 <strong data-v-5f98098a>간편 수거 신청 버튼</strong>을 눌러주세요.</p></div><div class=\"d-none d-md-block\" data-v-5f98098a><p data-v-5f98098a><strong data-v-5f98098a>6월 5일 ‘환경의날’</strong>을 시작으로 하는 종이팩 재활용 캠페인</p><p data-v-5f98098a>종이 박스에 깨끗하게 말린 일반팩 / 멸균팩을 차곡 차곡 쌓고 <strong data-v-5f98098a>간편 수거 신청 버튼</strong>을 눌러주세요.</p></div>", 3)
const _hoisted_6 = { class: "steps" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "box box-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 리워드 발송 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "수거가 완료된 순서로 순차발송", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(온라인 참여자에 한함)", -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "box box-3" }
const _hoisted_17 = { class: "item item-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "30개"),
  /*#__PURE__*/_createTextVNode(" 챌린지 리워드 ")
], -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "* 올바르게 분리배출된 종이팩은 휴지로 멋지게 변신할 수 있어요.", -1))
const _hoisted_22 = { class: "item item-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "100개"),
  /*#__PURE__*/_createTextVNode(" 챌린지 리워드 ")
], -1))
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "d-block d-md-none box box-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "최고의 팩체인저"),
  /*#__PURE__*/_createTextVNode("를 찾아라! ")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, " 우수 참여자에게 드리는 선물 ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("p", null, "캠페인 기간 동안"),
  /*#__PURE__*/_createElementVNode("p", null, "가장 많은 종이팩을 모아 보내주신 20분께"),
  /*#__PURE__*/_createElementVNode("p", null, "친환경 설거지 비누, 자연 수세미, 나무수저 세트, "),
  /*#__PURE__*/_createElementVNode("p", null, "분리수거 백, 대나무 칫솔, 고체 치약 등으로"),
  /*#__PURE__*/_createElementVNode("p", null, "구성된 친환경 키트를 선물로 드려요!")
], -1))
const _hoisted_30 = { class: "box-img" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("p", null, "* 해당 이벤트는 캠페인 기간동안 테라사이클 홈페이지에서 "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "수거 신청을 완료해주신 분들 대상으로 자동 응모"),
    /*#__PURE__*/_createTextVNode("되며, ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "결과는 수거 기간 종료(8/23) 후 한달 내"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "테라사이클 인스타그램(@terracycle_korea)에서")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "공지 및 개별 연락"),
    /*#__PURE__*/_createTextVNode(" 드립니다.")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "* 우수 참여자는 보내주신 종이팩들의 무게를 기준으로 선정됩니다.")
], -1))
const _hoisted_33 = { class: "d-none d-md-block box box-4-pc" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"subtitle\" data-v-5f98098a> 우수 참여자에게 드리는 선물 </div><h3 class=\"title\" data-v-5f98098a> 최고의 팩체인저를 찾아라! </h3><div class=\"desc\" data-v-5f98098a><p data-v-5f98098a>캠페인 기간 동안 가장 많은 종이팩을 모아 보내주신 20분께</p><p data-v-5f98098a>친환경 설거지 비누, 자연 수세미, 나무수저 세트, 분리수거 백, </p><p class=\"margin-bottom\" data-v-5f98098a> 대나무 칫솔, 고체 치약 등으로 구성된 친환경 키트를 선물로 드려요! </p><p data-v-5f98098a>* 해당 이벤트는 캠페인 기간동안 테라사이클 홈페이지에서 수거 신청을</p><p data-v-5f98098a>완료해주신 분들 대상으로 자동 응모되며, 결과는 수거 기간 종료(8/23) 후</p><p data-v-5f98098a>한달 내 테라사이클 인스타그램(@terracycle_korea)에서 </p><p class=\"margin-bottom\" data-v-5f98098a> 공지 및 개별 연락 드립니다. </p><p data-v-5f98098a>* 우수 참여자는 보내주신 종이팩들의 무게를 기준으로 선정됩니다.</p></div>", 3)
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "box box-buttons" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button button-1" }, " 자주하는 질문 확인하기 > ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button button-2" }, " 유의사항 확인하기 > ", -1))

import ImageStep1 from '../../images/page-2/step-1.png';
import ImageStep2 from '../../images/page-2/step-2.png';
import ImageStep3 from '../../images/page-2/step-3.png';
import ImageMessageMobile from '../../images/page-2/message-mobile.png';
import ImageMessagePC from '../../images/page-2/message-pc.png';
import Image1 from '../../images/page-2/image-1.png';
import Image1PC from '../../images/page-2/image-1-pc.png';
import Image2 from '../../images/page-2/image-2.png';
import Image2PC from '../../images/page-2/image-2-pc.png';
import Image3Mobile from '../../images/page-2/image-3-mobile.png';
import Image3PC from '../../images/page-2/image-3-pc.png';
import DialogNotice from './dialog-notice.vue';
import DialogFAQ from './dialog-faq.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: _unref(ImageStep1),
          class: "step"
        }, null, 8, _hoisted_7),
        _createElementVNode("img", {
          src: _unref(ImageStep2),
          class: "step"
        }, null, 8, _hoisted_8),
        _createElementVNode("img", {
          src: _unref(ImageStep3),
          class: "step"
        }, null, 8, _hoisted_9)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("img", {
        src: _unref(ImageMessageMobile),
        class: "d-inline-block d-md-none image-message",
        loading: "lazy"
      }, null, 8, _hoisted_14),
      _createElementVNode("img", {
        src: _unref(ImageMessagePC),
        class: "d-none d-md-inline-block image-message",
        loading: "lazy"
      }, null, 8, _hoisted_15)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("img", {
          src: _unref(Image1),
          class: "d-inline-block d-md-none"
        }, null, 8, _hoisted_19),
        _createElementVNode("img", {
          src: _unref(Image1PC),
          class: "d-none d-md-inline-block"
        }, null, 8, _hoisted_20),
        _hoisted_21
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("img", {
          src: _unref(Image2),
          class: "d-inline-block d-md-none",
          loading: "lazy"
        }, null, 8, _hoisted_24),
        _createElementVNode("img", {
          src: _unref(Image2PC),
          class: "d-none d-md-inline-block",
          loading: "lazy"
        }, null, 8, _hoisted_25)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _hoisted_28,
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("img", {
          src: _unref(Image3Mobile),
          class: "image"
        }, null, 8, _hoisted_31)
      ]),
      _hoisted_32
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("img", {
        src: _unref(Image3PC),
        class: "image"
      }, null, 8, _hoisted_37)
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createVNode(DialogFAQ, null, {
        default: _withCtx(() => [
          _hoisted_39
        ]),
        _: 1
      }),
      _createVNode(DialogNotice, null, {
        default: _withCtx(() => [
          _hoisted_40
        ]),
        _: 1
      })
    ])
  ]))
}
}

})